import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import AppleState from '../../types/AppleState'

const mutations: MutationTree<AppleState> = {}

export default mutations
